module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "header__left"
  }, [(!_vm.$store.state.logoURL) ? _c('img', {
    attrs: {
      "src": "https://assets-cdn.signable.co.uk/images/signable-full-white.svg"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.$store.state.logoURL
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "header__right"
  }, [_c('h2', {
    staticClass: "header__heading"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    class: ("header header--mobile " + (_vm.isHidden ? 'header--hidden' : ''))
  }, [_c('div', {
    staticClass: "header__item"
  }, [_c('a', {
    staticClass: "header__action-item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showSideBarInfo
    }
  }, [_c('icon', {
    attrs: {
      "name": "bars",
      "height": "25",
      "width": "25"
    }
  })], 1)]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_c('a', {
    staticClass: "header__action-item float-right",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.showHelp
    }
  }, [_c('icon', {
    attrs: {
      "name": "question-circle",
      "height": "25",
      "width": "25"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "header__title"
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header__item"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.svg"),
      "height": "50"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b01119e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 1058
// module chunks = 1